import { render, staticRenderFns } from "./DiscountOnSupplyPrice.vue?vue&type=template&id=3a5c125c&scoped=true"
import script from "./DiscountOnSupplyPrice.vue?vue&type=script&lang=js"
export * from "./DiscountOnSupplyPrice.vue?vue&type=script&lang=js"
import style0 from "./DiscountOnSupplyPrice.vue?vue&type=style&index=0&id=3a5c125c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c125c",
  null
  
)

export default component.exports